import SectionHeader from "../../components/commonUi/SectionHeader";

const Documentation = () => {
  return (
    <div className="px-7">
      <SectionHeader
        title={"Documentation"}
        objective={"Monitor and Analyze key data metrices and KPIs."}
      />
    </div>
  );
};

export default Documentation;
